import { Expose } from "class-transformer";

export class AssignPlanningBoardVehicleDto {
  @Expose()
  planningBoardProjectId: string;

  @Expose()
  vehicleId: string;

  @Expose()
  updatedById: string;
}
